<template>
  <div class="appie-signup-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="appie-signup-box">
            <span>On vous tient informer de tout…</span>
            <h3 class="title">Commencez.</h3>
            <form action="#">
              <div class="input-box">
                <input type="text" placeholder="Entrer votre nom" />
              </div>
              <div class="input-box">
                <input type="email" placeholder="Entrer votre email" />
              </div>
              <div class="input-box">
                <button type="submit">S'inscrire</button>
              </div>
              <div class="appie_checkbox_common checkbox_style2">
                <div>
                  <input type="checkbox" name="checkbox2" id="checkbox4" />
                  <label for="checkbox4"
                    ><span></span>By signing up you agree to our
                    <a href="#">Terms & Conditions.</a></label
                  >
                </div>
              </div>
            </form>
            <div class="thumb">
              <img src="@/assets/images/signup-thumb.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.input-box button {
  border: #fff solid 1px !important;
}
</style>
